import { findIndex } from "ramda";
import {
  IChoiceExerciseContent,
  IChoiceExerciseItem,
  ILocalizedChoiceExerciseItem,
  ISingleChoiceExercise,
} from "../../../../types";
import { IChoicesProps, IChooseChoiceExerciseAnswerDependencies } from "./Choices.types";

export const localizedChoices = (props: IChoicesProps): ILocalizedChoiceExerciseItem[] => {
  if (props.choices) {
    return props.choices
      .filter(choice => !choice.deleted)
      .map<ILocalizedChoiceExerciseItem>((choice, index) => ({
        correct: choice.correct,
        hint: choice.hint.elems.find(l => l.locale === props.currentLocale) || null,
        id: choice.id,
        sort: index,
        text: choice.text.elems.find(l => l.locale === props.currentLocale) || null,
      }));
  }

  return [];
};

export const chooseCorrectAnswer = ({
  exercise,
  chooseMultipleChoiceAnswers,
  chooseSingleChoiceAnswer,
}: IChooseChoiceExerciseAnswerDependencies) => (choice: ILocalizedChoiceExerciseItem) => () => {
  const { content } = exercise;
  if (!content.singleChoice) {
    chooseMultipleChoiceAnswers();
  } else {
    if (isPreviouslySelectedAnswer(content, choice)) {
      return;
    }
    chooseSingleChoiceAnswer({
      exercise: exercise as ISingleChoiceExercise,
      selectedAnswerIndex: choice.id,
    });
  }
};

export const isPreviouslySelectedAnswer = (content: IChoiceExerciseContent, choice: ILocalizedChoiceExerciseItem) => {
  const previousAnswerIndex = findIndex<IChoiceExerciseItem>(i => !i.deleted && i.correct)(content.items.elems);
  if (previousAnswerIndex !== -1 && content.items.elems[previousAnswerIndex].id === choice.id) {
    return true;
  }
  return false;
};
